<template>
  <div
    class="items-center mb-8 pb-6 border-b border-gray-400 border-opacity-20 w-full px-4"
  >
    <div class="text-3xl font-bold font-heading text-gray-100 text-left">
      <slot></slot>
    </div>
  </div>
</template>
